import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { cn } from '@/lib/utils';
import { isWidgetExpandedState } from '@/state/session';
import { validateYouTubeUrl } from '@/util/utils';
export const Video = ({ name, url }) => {
    const { t } = useTranslation();
    const isExpanded = useRecoilValue(isWidgetExpandedState);
    const validYoutubeUrl = validateYouTubeUrl(url);
    return (_jsx(_Fragment, { children: validYoutubeUrl ? (_jsx("iframe", { title: name, width: "100%", height: "265", allowFullScreen: true, src: validYoutubeUrl })) : (
        /* eslint-disable-next-line jsx-a11y/media-has-caption */
        _jsxs("video", { className: cn('w-xs duration-250 rounded-xl transition-all ease-out', {
                'w-full': isExpanded,
            }), controls: true, title: name, children: [_jsx("source", { src: url, type: "video/mp4" }), _jsx("p", { children: t('message.video_unsupported') })] })) }));
};
